// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__LuL7m","description":"PatientConsentPreview_description__2ziJx"};